export default '/:locale(ar|en)?/:productSearchString/t-p/';
